var metric, imperial;

metric = {
  "Pa.s": {
    name: {
      singular: "Pascal-second",
      plural: "Pascal-seconds",
    },
    to_anchor: 1,
  },
  "mPa.s": {
    name: {
      singular: "Millipascal-second",
      plural: "Millipascal-seconds",
    },
    to_anchor: 0.001,
  },
  P: {
    name: {
      singular: "Poise",
      plural: "Poises",
    },
    to_anchor: 0.1,
  },
  cP: {
    name: {
      singular: "Centipoise",
      plural: "Centipoises",
    },
    to_anchor: 0.001,
  },
  "N.s/m²": {
    name: {
      singular: "Newton-second per square meter",
      plural: "Newton-seconds per square meter",
    },
    to_anchor: 1,
  },
  "kg/(m·s)": {
    name: {
      singular: "Kilogram per meter-second",
      plural: "Kilograms per meter-second",
    },
    to_anchor: 1,
  },
  "dyn.s/cm²": {
    name: {
      singular: "Dyne-second per square centimeter",
      plural: "Dyne-seconds per square centimeter",
    },
    to_anchor: 0.1,
  },
  reyn: {
    name: {
      singular: "Reyn",
      plural: "Reyns",
    },
    to_anchor: 6894.757,
  },
};

imperial = {
  "lbf.s/ft²": {
    name: {
      singular: "Pound-force second per square foot",
      plural: "Pound-force seconds per square foot",
    },
    to_anchor: 47.88026,
  },
  "lb/(ft.s)": {
    name: {
      singular: "Pound per foot-second",
      plural: "Pounds per foot-second",
    },
    to_anchor: 1.488164,
  },
};

module.exports = {
  metric: metric,
  imperial: imperial,
  _anchors: {
    metric: {
      unit: "Pa.s",
      ratio: 1 / 47.88026, // 1 Pa·s = 0.02088 lbf.s/ft²
    },
    imperial: {
      unit: "lbf.s/ft²",
      ratio: 47.88026, // 1 lbf.s/ft² = 47.88026 Pa.s
    },
  },
};
